<div class="add-dealer-phone-container">
  <div class="header">
    <mat-icon class="back-arrow" (click)="goBack()">chevron_left</mat-icon>
    <span class="title">{{ isEditFlow ? 'Edit Dealer Details' : 'Verify mobile number' }}</span>
    <span class="page-indicator"><span style="font-weight: 1000;font-size: larger;">1</span>/3</span>
  </div>

  <div class="content-section">
    <div class="form-field">
      <label for="phoneNumber" class="required">We will send an sms to verify the agro dealer's phone number</label>
      <input
        type="tel"
        id="phoneNumber"
        [(ngModel)]="phoneNumber"
        (input)="onPhoneNumberInput()"
        name="phoneNumber"
        placeholder="Enter Agro dealer's mobile number"
        maxlength="10"
        pattern="^[0-9]{9,10}$"
        [disabled]="isEditFlow"
        required
      />
    </div>
</div>

  <div class="button-wrapper">
    <button
      mat-raised-button
      color="primary"
      class="verify-button"
      [disabled]="!isPhoneNumberValid"
      (click)="onVerifyPhoneNumber()"
    >
      <span>Verify Mobile Number</span>
    </button>
  </div>
</div>